export const VAT_CODE_REGEX = /^[0-9]{11}$/;
export const FISCAL_CODE_REGEX = /^(\d{11}|[a-zA-Z]{6}\d{2}[a-zA-Z]\d{2}[a-zA-Z]\d{3}[a-zA-Z])$/;
export const POSTAL_CODE_REGEX = /^\d{5}$/;
export const PROVINCE_REGEX = /^[A-Z]{2}$/;
